import { Box, Stack } from '@mui/material';
import useDraggableEmergencyPosition from '../hooks/useDraggableEmergencyPosition';
import useInterruptionsEmergencyController from '../hooks/useInterruptionsEmergencyController';
import InterruptionsEmergencyCard from './card/InterruptionsEmergencyCard';
import InterruptionsEmergencyHeader from './InterruptionsEmergencyHeader';
import { useAvailabilityCurrentUser } from 'domain/people/availability/availabilityUser/AvailabilityCurrentUserProvider';

const ROOT_SX = {
  position: 'fixed',
  width: 360,
  zIndex: 1400,
} as const;

const InterruptionsEmergencyOverlay = () => {
  const { isAvailabilityEnabled } = useAvailabilityCurrentUser();
  const { cards, onAccept, onCancel, onDismiss, onExpire, onPostpone } = useInterruptionsEmergencyController();
  const { containerRef, dragHandlers, position } = useDraggableEmergencyPosition();

  if (!isAvailabilityEnabled) {
    return null;
  }

  if (cards.length === 0) {
    return null;
  }

  return (
    <Box
      ref={containerRef}
      sx={{
        ...ROOT_SX,
        ...(position ? { left: position.x, top: position.y } : { right: 16, top: 16 }),
      }}
      {...dragHandlers}
    >
      <InterruptionsEmergencyHeader />
      <Stack spacing={1}>
        {cards.map(card => (
          <InterruptionsEmergencyCard
            key={card.id}
            item={card}
            onAccept={onAccept}
            onCancel={onCancel}
            onDismiss={onDismiss}
            onExpire={onExpire}
            onPostpone={onPostpone}
          />
        ))}
      </Stack>
    </Box>
  );
};

export default InterruptionsEmergencyOverlay;
